<template>
  <iframe
    :src="rmasrc"
    ref="theframe"
    style="border: 0; position: absolute; height: 100%; width: 100%; left: 0; top: 0;"
  ></iframe>
</template>

<script>

export default {
  name: "rmalabel",
  data: () => ({
  }),
computed: {
    rmasrc() {
      return "https://qgistix.com/labels/frame?nocache=" + (new Date()).getTime() 
    }
  },
  methods: {
  },
  mounted()
  {
    console.log("rmalabel mounted called")
    // create cookies
    let domainroot = window.location.hostname.split('.').reverse().splice(0,2).reverse().join('.')
    console.log("cookie domainroot: " + domainroot)
    this.$cookies.set("qgbranch", this.$store.state.auth.profile["custom:brid"], 0, "/", domainroot)
    this.$cookies.set("qgclient", this.$store.state.auth.profile["custom:client_id"], 0, "/", domainroot)
    this.$cookies.set("qgname", this.$store.state.auth.profile.given_name, 0, "/", domainroot)
    this.$cookies.set("qgrole", this.$store.state.auth.profile["custom:role"], 0, "/", domainroot)
    this.$cookies.set("qguser", this.$store.state.auth.profile.preferred_username, 0, "/", domainroot)
  }
}
</script>
